// extracted by mini-css-extract-plugin
module.exports = {"text":"address-module--text--32a4f"};